// import React from 'react';
// import { FaReact, FaPython, FaJava, FaNodeJs, FaAws, FaDatabase, FaMobile, FaBrain } from 'react-icons/fa';
// import { SiMongodb, SiKubernetes, SiDocker, SiTensorflow } from 'react-icons/si';

// const Technologies = () => {
//   const technologies = [
//     { name: 'React', icon: <FaReact />, color: 'text-blue-500' },
//     { name: 'Python', icon: <FaPython />, color: 'text-yellow-500' },
//     { name: 'Java', icon: <FaJava />, color: 'text-red-600' },
//     { name: 'Node.js', icon: <FaNodeJs />, color: 'text-green-600' },
//     { name: 'AWS', icon: <FaAws />, color: 'text-orange-500' },
//     { name: 'MongoDB', icon: <SiMongodb />, color: 'text-green-500' },
//     { name: 'Database', icon: <FaDatabase />, color: 'text-blue-600' },
//     { name: 'Mobile Dev', icon: <FaMobile />, color: 'text-purple-600' },
//     { name: 'AI/ML', icon: <FaBrain />, color: 'text-pink-600' },
//     { name: 'Kubernetes', icon: <SiKubernetes />, color: 'text-blue-700' },
//     { name: 'Docker', icon: <SiDocker />, color: 'text-blue-600' },
//     { name: 'TensorFlow', icon: <SiTensorflow />, color: 'text-orange-600' }
//   ];

//   return (
//     <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50" data-testid="technologies-section">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center mb-16">
//           <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
//             Technologies We <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Train On</span>
//           </h2>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto">
//             Learn the latest and most in-demand technologies from industry experts
//           </p>
//         </div>

//         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
//           {technologies.map((tech, index) => (
//             <div
//               key={index}
//               className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 flex flex-col items-center justify-center group"
//               data-testid={`tech-card-${index}`}
//             >
//               <div className={`text-5xl ${tech.color} mb-3 group-hover:scale-110 transition-transform`}>
//                 {tech.icon}
//               </div>
//               <div className="text-sm font-semibold text-gray-700 text-center">
//                 {tech.name}
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Technologies;
import React, { useState } from 'react';
import { FaReact, FaPython, FaJava, FaNodeJs, FaAws, FaDatabase, FaMobile, FaBrain } from 'react-icons/fa';
import { SiMongodb, SiKubernetes, SiDocker, SiTensorflow } from 'react-icons/si';

const Technologies = () => {
  // Track which card is currently hovered so we know which detail panel to show.
  // null = nothing hovered = no detail panel visible.
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const technologies = [
    {
      name: 'React',
      icon: <FaReact />,
      color: 'text-blue-500',
      description: 'A JavaScript library for building fast, interactive user interfaces using reusable components.'
    },
    {
      name: 'Python',
      icon: <FaPython />,
      color: 'text-yellow-500',
      description: 'A versatile, readable language widely used for automation, data science, and backend development.'
    },
    {
      name: 'Java',
      icon: <FaJava />,
      color: 'text-red-600',
      description: 'A robust, object-oriented language trusted for large-scale enterprise and Android applications.'
    },
    {
      name: 'Node.js',
      icon: <FaNodeJs />,
      color: 'text-green-600',
      description: 'A runtime that lets JavaScript power fast, scalable backend servers and APIs.'
    },
    {
      name: 'AWS',
      icon: <FaAws />,
      color: 'text-orange-500',
      description: 'A leading cloud platform for hosting, storage, and scalable infrastructure.'
    },
    {
      name: 'MongoDB',
      icon: <SiMongodb />,
      color: 'text-green-500',
      description: 'A flexible NoSQL database designed for handling large volumes of unstructured data.'
    },
    {
      name: 'Database',
      icon: <FaDatabase />,
      color: 'text-blue-600',
      description: 'Core concepts of storing, querying, and managing structured data efficiently.'
    },
    {
      name: 'Mobile Dev',
      icon: <FaMobile />,
      color: 'text-purple-600',
      description: 'Building responsive, native-quality apps for iOS and Android devices.'
    },
    {
      name: 'AI/ML',
      icon: <FaBrain />,
      color: 'text-pink-600',
      description: 'Training models and algorithms that let systems learn patterns and make predictions.'
    },
    {
      name: 'Kubernetes',
      icon: <SiKubernetes />,
      color: 'text-blue-700',
      description: 'An orchestration platform for deploying and managing containerized applications at scale.'
    },
    {
      name: 'Docker',
      icon: <SiDocker />,
      color: 'text-blue-600',
      description: 'A tool for packaging applications into lightweight, portable containers.'
    },
    {
      name: 'TensorFlow',
      icon: <SiTensorflow />,
      color: 'text-orange-600',
      description: 'An open-source framework for building and training machine learning models.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50" data-testid="technologies-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Technologies We <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Train On</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Learn the latest and most in-demand technologies from industry experts
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {technologies.map((tech, index) => (
            <div
              key={index}
              className="relative"
              // Show the detail panel for this card on hover, hide it on mouse out.
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div
                className="bg-white rounded-xl p-6 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 flex flex-col items-center justify-center group"
                data-testid={`tech-card-${index}`}
              >
                <div className={`text-5xl ${tech.color} mb-3 group-hover:scale-110 transition-transform`}>
                  {tech.icon}
                </div>
                <div className="text-sm font-semibold text-gray-700 text-center">
                  {tech.name}
                </div>
              </div>

              {/* Detail panel: only rendered while this card is hovered */}
              {hoveredIndex === index && (
                <div
                  className="absolute left-1/2 -translate-x-1/2 bottom-[calc(100%+10px)] w-56 bg-gray-900 text-white text-sm rounded-lg shadow-xl p-4 z-10 pointer-events-none"
                  data-testid={`tech-detail-${index}`}
                >
                  <p className="leading-relaxed">{tech.description}</p>
                  {/* small arrow pointing down to the card */}
                  <div className="absolute left-1/2 -translate-x-1/2 top-full w-3 h-3 bg-gray-900 rotate-45"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Technologies;